import { AuthenticationService } from './../core/services/authentication.service';
import { KeycloakService } from 'keycloak-angular';
import { EnvironmentService } from './environment.service';

export function initializeKeycloak(
  keycloak: KeycloakService,
  environmentser: EnvironmentService,
  authenticationService: AuthenticationService
) {
  return () => {
    return new Promise(async (resolve, reject) => {
      try {
        await keycloak
          .init({
            config: {
              url: environmentser.getAuthURL(),
              realm: 'administration',
              clientId: 'administration',
            },
            initOptions: {
              onLoad: 'login-required',
              checkLoginIframe: false,
            },
            enableBearerInterceptor: true,
            bearerExcludedUrls: ['/assets', '/clients/public'],
          })
          .then((b) => {
            console.log('init done');
          });

        const keycloakAuth = keycloak.getKeycloakInstance();

        authenticationService.onAuthenticationSuccess(keycloakAuth.token??'');

        keycloakAuth.onTokenExpired = () => {
          console.debug('expired ' + new Date());
          keycloakAuth
            .updateToken(100000)
            .then((refreshed) => {
              if (refreshed) {
                console.debug('refreshed ' + new Date());
              } else {
                console.debug('not refreshed ' + new Date());
              }
            })
            .catch(() => {
              console.error('Failed to refresh token ' + new Date());
            });
        };

        resolve('');
      } catch (error) {
        reject(error);
      }
    });
  };
}
